import Navbar from '../components/navbar';
import Footer from '../components/footer';
import { useTranslation } from 'react-i18next';

import desc_2 from '../images/aPropos/desc-2.png';
import desc_3 from '../images/aPropos/desc-3.png';
import GroupeDLA from '../images/aPropos/GroupeDLA.jpg';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHandshake, faUsers, faArrowUpRightDots } from '@fortawesome/free-solid-svg-icons';
import useAos from '../hooks/useAos';
import { PageMeta } from '../seo/PageMeta';

const VALUE_KEYS = [
    { key: 'respect', icon: faHandshake },
    { key: 'teamwork', icon: faUsers },
    { key: 'improvement', icon: faArrowUpRightDots },
];

function Propos() {
    const { t } = useTranslation('pages');

    return (
        <div className="flex justify-center flex-column items-center py-96 overflow-hidden w-full" data-navbar-theme="light">
            <div className="overflow-hidden w-full px-20">
                <p className="text-title text-bold fustat text-center" data-aos="fade-up">
                    {t('about.heroLine1')} <br/><span className="text-underline">{t('about.heroLine2')}</span>
                </p>
            </div>
            <div className="self-stretch mx-64 mb-64">
                <p className="text-subtitle outfit text-center mb-32" data-aos="fade-up" data-aos-delay="150">{t('about.intro1')}</p>
                <div className="my-32" data-aos="fade-up" data-aos-delay="300">
                    <img src={GroupeDLA} alt="Description 1" className="w-full block object-cover" />
                </div>
                <p className="text-subtitle outfit text-center mt-32" data-aos="fade-up" data-aos-delay="450">{t('about.intro2')}</p>
            </div>

            <div className="bg-gray w-full flex flex-column px-64 py-64 mb-64" data-navbar-theme="dark">
                <div className="flex justify-end tablet-justify-start w-full">
                    <p className="w-50 text-subtitle outfit t-white text-right tablet-text-left m-0" data-aos="fade-up">
                        {t('about.qualityText')}
                    </p>
                </div>
                <div className="flex justify-start tablet-justify-center w-full mt-64" data-aos="fade-up" data-aos-delay="150">
                    <img src={desc_2} alt={t('about.constructionSiteAlt')} className="w-full block object-cover" />
                </div>
            </div>

            <div className="w-full flex flex-column px-64 mb-64" data-navbar-theme="light">
                <div className="flex justify-start w-full">
                    <p className="w-50 text-subtitle outfit text-left m-0" data-aos="fade-up">
                        {t('about.listeningText')}
                    </p>
                </div>
                <div className="flex justify-center w-full mt-64" data-aos="fade-up" data-aos-delay="150">
                    <img src={desc_3} alt={t('about.constructionSiteAlt')} className="w-full block object-cover" />
                </div>
            </div>
        </div>
    );
}

function Definit() {
    const { t } = useTranslation('pages');

    return (
        <div className="bg-gray w-full flex flex-column px-64 py-64" data-navbar-theme="dark">
            <p className="text-title3 t-white text-semibold fustat text-center m-0" data-aos="fade-up">{t('about.definesTitle')}</p>

            <div className="flex flex-column gap-32 w-full mt-64 tablet-items-center">
                {VALUE_KEYS.map(({ key, icon }, index) => (
                    <div key={key} className="propos-value-card" data-aos="fade-up" data-aos-delay={index * 150}>
                        <p className="propos-value-card__title text-title2 t-white fustat text-semibold m-0">
                            {t(`about.values.${key}.title`)}
                        </p>

                        <div className="propos-value-card__body">
                            <div className="propos-value-card__icon">
                                <FontAwesomeIcon icon={icon} className="propos-value-card__icon-svg" />
                            </div>
                            <div className="propos-value-card__separator" aria-hidden="true" />
                            <p className="propos-value-card__description text-subtitle2 t-white outfit text-light m-0">
                                {t(`about.values.${key}.description`)}
                            </p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default function ProposPage() {
    useAos();
    const { t } = useTranslation('pages');

    return (
        <>
            <PageMeta
                title={t('meta.about.title')}
                description={t('meta.about.description')}
                path="/a-propos"
            />
            <Navbar />
            <Propos />
            <Definit />
            <Footer />
        </>
    );
}
